<!--
  下载提示条: "下载APP,获取更多福利" + 下载按钮。
  原本只内联在首页顶部(TabHome); 抽成组件后, smd=1(牢记域名)场景下还会展示在登录页、我的页底部。
  showClose=true 时左侧带关闭按钮(首页顶部用), 关闭逻辑由父级通过 @close 处理。
-->
<template>
  <div class="hDownloadBar">
    <img v-if="showClose" @click="$emit('close')" :src="icon_down_close" height="18px" alt="">
    <img :src="icon_logo" height="29px" alt="" style="margin:0 10px">
    <div style="display:flex;flex-direction:column;flex:1;align-items:flex-start;justify-content:center;">
      <div :style="hcf.getTextStyle({addSize:-1.5,color:'#444'})">下载APP,获取更多福利</div>
      <div :style="hcf.getTextStyle({addSize:-3,color:'#888'})">真人娱乐,电子棋牌等尽在一手掌握</div>
    </div>
    <img @click="clickTopDown" :src="icon_down_btn" height="29px" alt="">
  </div>
</template>

<script setup>
  import {onUnmounted} from "vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {showDialog} from "vant";
  import icon_down_btn from '@/assets/icons/home/top_download_btn.png';
  import icon_down_close from '@/assets/icons/home/top_download_close.png';
  import icon_logo from '@/assets/icons/logo_biao.png';

  defineProps({showClose: {type: Boolean, default: false}});
  defineEmits(["close"]);

  const useComApi = useHComApi();
  let downTimer = null;

  function clickTopDown() {
    if (hdi.platTypeNo === 3) {
      hcf.launchUrl(useComApi.h5DownloadIosUrl.value + "?code=" + hdi.inviteCode);
      if (downTimer) {
        clearTimeout(downTimer);
        downTimer = null;
      }
      downTimer = setTimeout(() => {
        showDialog({
          title: 'iPhone轻量版安装步骤',
          message: "\n1.打开 【设置】-【通用】-【VPN与设备管理】\n2.选择《永利皇宫》\n3.点击右上角【安装】按钮\n\n*安装后请返回主屏幕查看\n*如有遇到任何问题,请联系在线客服",
          confirmButtonText: "知道了",
          confirmButtonColor: hcf.getMainColor(),
          messageAlign: "left"
        });
      }, 3000);
    } else {
      hcf.launchUrl(useComApi.h5DownloadApkUrl.value + "?code=" + hdi.inviteCode)
    }
  }

  onUnmounted(() => {
    if (downTimer) {
      clearTimeout(downTimer);
      downTimer = null;
    }
  });
</script>

<style scoped>
  .hDownloadBar {
    display: flex;
    flex-direction: row;
    height: 60px;
    width: 100%;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(to right, #FFF1C7, #FEF3E1);
  }
</style>
